<script setup lang="ts">
import BaseSvg from '@clovyr/bed/components/icons/BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon icon-restore" width="19" height="20" viewBox="0 0 19 20" fill="none">
    <path
      d="M13.5244 5.14284C10.8421 2.92026 6.86591 3.29294 4.64333 5.97524C3.51727 7.33421 3.05738 9.02532 3.22653 10.6522"
      stroke="#33E672"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M0.859863 9.12939L3.24123 11.8349L5.94669 9.45348"
      stroke="#33E672"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.4756 14.8567C8.1579 17.0793 12.1341 16.7066 14.3567 14.0243C15.4827 12.6653 15.9426 10.9742 15.7735 9.34729"
      stroke="#33E672"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M18.1401 10.8701L15.7588 8.16466L13.0533 10.546"
      stroke="#33E672"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </BaseSvg>
</template>
